// src/service/seo-insight-tracking.service.js
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8082';
const INSIGHT_STORAGE_KEY = 'pending_insight_id';

// Create axios instance with auth token
const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Track a new SEO insight (anonymous - only URL)
 */
export const trackSeoInsight = async (url) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/seo-insights/track`,
      { url },
      { headers: getAuthHeaders() }
    );
    return response.data; // Returns the insight ID
  } catch (error) {
    console.error('Error tracking SEO insight:', error);
    throw error;
  }
};

/**
 * Attach email to existing insight (after login)
 */
export const attachEmailToInsight = async (insightId, email) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/api/seo-insights/attach-email/${insightId}`,
      { email },
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error('Error attaching email to insight:', error);
    throw error;
  }
};

/**
 * Store insight ID in session storage for later attachment
 */
export const storeInsightId = (insightId) => {
  sessionStorage.setItem(INSIGHT_STORAGE_KEY, insightId.toString());
  console.log('📝 Stored insight ID:', insightId);
};

/**
 * Get stored insight ID from session storage
 */
export const getStoredInsightId = () => {
  const id = sessionStorage.getItem(INSIGHT_STORAGE_KEY);
  return id ? parseInt(id, 10) : null;
};

/**
 * Clear stored insight ID from session storage
 */
export const clearStoredInsightId = () => {
  sessionStorage.removeItem(INSIGHT_STORAGE_KEY);
  console.log('🗑️ Cleared stored insight ID');
};